var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('all-country-greetings'),_c('div',{staticClass:"bg-white py-40"},[_c('AllCountryGreetingsAndChartForm')],1),_c('AllCountryKeyStatisticsForm'),_c('AllCountryKeyServiceGreetings'),_c('AllCountryKeyServiceForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }